import React, { useContext } from 'react';
import Heading from '@influitive/secret-garden/lib/heading';
import Paragraph from '@influitive/secret-garden/lib/paragraph';
import * as R from 'ramda';

import Badges from './badges';
import Context from '../context';
import { setSelectedBadges } from '../actions';

export default ({ allBadges, selectedBadges }) => {
  const { dispatch } = useContext(Context);

  return <React.Fragment>
    <Heading level={4}>
      Add badges
    </Heading>

    <Paragraph>
      Select badges to add to this level
    </Paragraph>

    <Badges
      badges={allBadges}
      selectedBadges={selectedBadges}
      setSelectedBadges={R.compose(dispatch, setSelectedBadges)} />
  </React.Fragment>;
};
